//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'landingPageFooterXhs',
  data () {
    return {}
  }
}



// WEBPACK FOOTER //
// ./src/components/LandingPageFooterXhs.vue